import { render, staticRenderFns } from "./RadiosField.vue?vue&type=template&id=b2f096b6"
import script from "./RadiosField.vue?vue&type=script&lang=js"
export * from "./RadiosField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports